export const PATH_SEARCH_FOR_PRODUCTS = '/search-form';
export const PATH_SEARCH_RESULTS = '/search-results';
export const PATH_LOCK_SUMMARY = '/lock-summary';
export const PATH_LOGIN = '/login';
export const PATH_LOCK_EXTENSION = '/lock-extension';
